import React from "react";
import { css } from "glamor";
import LobbyLayout from "../lobby/LobbyLayout";
import Link from "../library/Link";
import Button from "../library/Button";
import { CardForm, TextField } from "../library/forms";
import { spacing, typographyColors } from "../library/theme";

const linkClass = css({
  color: typographyColors.defaultBody,
  "&:hover": { color: "rgba(0,0,0,0.5)" },
});
const buttonMargin = css({ marginTop: spacing.m });

export default function SignInForm(props) {
  return (
    <LobbyLayout>
      <CardForm onSubmit={props.handleSubmit} error={props.error}>
        <p></p>
        <TextField
          name="password"
          type="password"
          icon="lock"
          iconPosition="left"
          label="Nova Senha"
          placeholder="*******"
          required
          fluid
        />
        <TextField
          name="password_confirmation"
          type="password"
          icon="lock"
          iconPosition="left"
          label="Confirme a Nova Senha"
          placeholder="*******"
          required
          fluid
        />
        <div className={buttonMargin}>
          <Button
            color="red"
            disabled={props.pristine || props.submitting}
            size="large"
            fluid
          >
            Criar nova senha
          </Button>
        </div>
      </CardForm>
      <Link to="/signin" className={linkClass}>
        Voltar para o login
      </Link>
    </LobbyLayout>
  );
}
